var _ellipse, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle2, _circle3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 240,
    viewBox: "0 0 323 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.145,
    cy: -11.1234,
    rx: 189.813,
    ry: 189.273,
    transform: "rotate(24.4579 251.145 -11.1234)",
    fill: "url(#paint0_radial_1524_1601)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 251.309,
    cy: -11.0491,
    r: 154.729,
    transform: "rotate(24.4579 251.309 -11.0491)",
    fill: "#EA1889"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M392.154 53.0128C407.696 18.8427 410.286 -19.8123 399.441 -55.7502C388.596 -91.6881 365.056 -122.458 333.207 -142.327C301.358 -162.196 263.372 -169.809 226.326 -163.748C189.28 -157.687 155.7 -138.365 131.844 -109.381C107.988 -80.3981 95.4818 -43.7306 96.6557 -6.21036C97.8296 31.3099 112.603 67.1239 138.225 94.559C163.846 121.994 198.568 139.179 235.92 142.913C273.273 146.647 310.709 136.674 341.253 114.852L251.309 -11.0491L392.154 53.0128Z",
    fill: "#9F18D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392.154 53.0128C406.256 22.008 409.734 -12.7836 402.047 -45.9662C394.361 -79.1488 375.94 -108.868 349.641 -130.514C323.343 -152.16 290.637 -164.524 256.596 -165.688C222.554 -166.852 189.08 -156.75 161.365 -136.951C133.65 -117.151 113.242 -88.7591 103.308 -56.1789C93.3731 -23.5987 94.4666 11.3492 106.418 43.2446C118.37 75.14 140.513 102.2 169.412 120.229C198.31 138.257 232.35 146.246 266.252 142.957L251.309 -11.0491L392.154 53.0128Z",
    fill: "#57F2B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M392.154 53.0128C404.824 25.1563 408.949 -5.83173 404.008 -36.0327C399.067 -66.2337 385.281 -94.2912 364.394 -116.657C343.506 -139.023 316.456 -154.693 286.663 -161.685C256.87 -168.678 225.672 -166.678 197.016 -155.94C168.359 -145.202 143.53 -126.207 125.669 -101.357C107.807 -76.508 97.7159 -46.9202 96.6703 -16.3355C95.6248 14.2492 103.672 44.457 119.795 70.4682C135.917 96.4793 159.391 117.125 187.247 129.796L251.309 -11.0491L392.154 53.0128Z",
    fill: "#EA1889"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M392.154 53.0128C403.399 28.2893 407.938 1.04144 405.315 -25.9923C402.692 -53.0259 392.999 -78.8929 377.211 -100.993C361.422 -123.094 340.094 -140.649 315.371 -151.894C290.648 -163.139 263.4 -167.678 236.366 -165.055C209.332 -162.432 183.465 -152.739 161.365 -136.951C139.265 -121.162 121.71 -99.8343 110.465 -75.1109C99.2193 -50.3875 94.6802 -23.1396 97.3033 3.89414C99.9263 30.9278 109.619 56.7948 125.408 78.8951L251.309 -11.0491L392.154 53.0128Z",
    fill: "#9F18D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M392.154 53.0128C401.98 31.4089 406.705 7.83417 405.963 -15.8878C405.221 -39.6097 399.031 -62.843 387.874 -83.7903C376.716 -104.738 360.889 -122.837 341.618 -136.69C322.346 -150.542 300.146 -159.775 276.735 -163.675C253.324 -167.575 229.33 -166.037 206.608 -159.181C183.887 -152.324 163.047 -140.332 145.701 -124.133C128.355 -107.934 114.969 -87.9623 106.576 -65.762C98.184 -43.5618 95.0112 -19.7285 97.3033 3.89412L251.309 -11.0491L392.154 53.0128Z",
    fill: "#57F2B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M392.154 53.0128C409.144 15.6584 410.6 -26.9153 396.2 -65.3428C381.8 -103.77 352.725 -134.903 315.371 -151.894C278.017 -168.884 235.443 -170.339 197.016 -155.94C158.588 -141.54 127.455 -112.465 110.465 -75.1109L251.309 -11.0491L392.154 53.0128Z",
    fill: "#EA1889"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M392.154 53.0128C406.256 22.008 409.734 -12.7836 402.047 -45.9662C394.361 -79.1488 375.94 -108.868 349.641 -130.514C323.343 -152.16 290.637 -164.524 256.596 -165.688C222.554 -166.852 189.08 -156.75 161.365 -136.951L251.309 -11.0491L392.154 53.0128Z",
    fill: "#9F18D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M392.154 53.0128C403.399 28.2893 407.938 1.04144 405.315 -25.9923C402.692 -53.0259 392.999 -78.8929 377.211 -100.993C361.422 -123.094 340.094 -140.649 315.371 -151.894C290.648 -163.139 263.4 -167.678 236.366 -165.055L251.309 -11.0491L392.154 53.0128Z",
    fill: "#57F2B9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M392.154 53.0128C400.567 34.5168 405.254 14.5449 405.948 -5.7626C406.642 -26.0701 403.33 -46.3154 396.2 -65.3428C389.07 -84.3701 378.262 -101.807 364.394 -116.657C350.525 -131.508 333.867 -143.481 315.371 -151.894L251.309 -11.0491L392.154 53.0128Z",
    fill: "#EA1889"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M392.154 53.0128C403.399 28.2893 407.938 1.04144 405.315 -25.9923C402.692 -53.0259 392.999 -78.8929 377.211 -100.993L251.309 -11.0491L392.154 53.0128Z",
    fill: "#9F18D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M392.154 53.0128C403.399 28.2893 407.938 1.04144 405.315 -25.9923L251.309 -11.0491L392.154 53.0128Z",
    fill: "#57F2B9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.22,
    cy: -11.2872,
    r: 25.0086,
    transform: "rotate(24.4579 251.22 -11.2872)",
    fill: "#D396ED"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.219,
    cy: -11.2871,
    r: 14.9332,
    transform: "rotate(24.4579 251.219 -11.2871)",
    fill: "#57F2B9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1524_1601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(136.853 -336.173) rotate(47.6614) scale(659.165 661.044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169475,
    stopColor: "#4B00CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B00CC",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRight);
export default __webpack_public_path__ + "static/media/top-right.1a8d22d2131b86cd8e4f88d4dc05cd86.svg";
export { ForwardRef as ReactComponent };